<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-titlepage title-page automatic-title-page" epub:type="titlepage" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title">Brother Blood Sister Death</h1>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-primary-block">
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name">Bill Ransom</span></h2>
</div>
</div>
<div class="publisher-block">
<div class="title-page-publisher-logo-block title-page-publisher-logo-aspect-square">
<div class="title-page-publisher-logo-size-container" style="width: 50%">
<img alt="WordFire Press" class="title-page-publisher-logo-image" src="images/original.jpg"/>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title-page.vue?0a3a02a4